import React, { useState } from 'react';
import axios from 'axios';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { fmtInt, fmtHours, fmtDecimal } from './starFormat';
import { HostDailyStatement } from './HostDailyStatement';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const HostPreviousCycle = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    if (data || loading) return;
    setLoading(true); setError('');
    axios.get(`${BACKEND_URL}/api/host-panel/my-previous-cycle`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('customer_token')}` } })
      .then((res) => setData(res.data))
      .catch((e) => setError(e.response?.data?.detail || 'Não foi possível carregar o ciclo anterior.'))
      .finally(() => setLoading(false));
  };

  const c = data?.comparison;
  const up = c && c.diff > 0;
  const flat = c && c.diff === 0;
  const Icon = flat ? Minus : up ? TrendingUp : TrendingDown;

  return (
    <div className="space-y-2" data-testid="host-previous-cycle-section">
      <HostDailyStatement
        testIdPrefix="host-prev-statement"
        title={`Ciclo anterior${data ? ` · ${data.window.start} → ${data.window.end}` : ''}`}
        statement={data?.statement}
        validDaysNote="estimativa"
        onOpen={load} loading={loading} error={error}
        topNote={data
          ? `A KAKO publica dias válidos só do ciclo em andamento. Aqui os ${fmtInt(data.valid_days_estimated)} dia(s) `
            + `são uma estimativa feita com a sua regra atual de ${fmtHours(data.min_video_minutes)} por dia`
            + `${data.exemption_applied ? ' (com a isenção de 1h)' : ''}.`
          : null} />

      {c && (
        <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-white/[0.07] bg-white/[0.03] px-3.5 py-2.5 text-[11px] text-zinc-300 backdrop-blur-md"
          data-testid="host-previous-cycle-comparison">
          <Icon className={`h-4 w-4 shrink-0 ${flat ? 'text-zinc-400' : up ? 'text-emerald-400' : 'text-rose-400'}`} />
          <span>
            Ciclo anterior: <span className="font-mono font-bold text-white">{fmtInt(c.previous_commission)}</span>{' '}
            cristais · ciclo atual até agora:{' '}
            <span className="font-mono font-bold text-white">{fmtInt(c.current_commission)}</span>
            {c.pct_change !== null && (
              <span className={`ml-1 font-mono font-bold ${up ? 'text-emerald-300' : flat ? 'text-zinc-400' : 'text-rose-300'}`}>
                ({up ? '+' : ''}{fmtDecimal(c.pct_change, 1)}%)
              </span>
            )}
          </span>
        </div>
      )}
    </div>
  );
};
